module.exports = __webpack_public_path__ + "assets/total_leads_contacted.b13cb8db.svg";